import React, { useEffect, useState } from "react";
import "./Styling.css";
import { useHistory, useLocation } from "react-router";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { contactUs } from "../../api/admin";
import ContactUsModal from "../Partials/ContactUsModal";
import { s3BaseUrl } from "../../config/envConfig";

const ContactUs: React.FC = () => {
  const loc = useLocation();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [newMobileNumber, setNewMobileNumber] = useState(""); // New state for new mobile number
  const [email, setEmail] = useState("");
  const [queryType, setQueryType] = useState("");
  const [message, setMessage] = useState("");
  const options = loc.state?.forgotPassword
    ? ["Forgot Username and Password", "New / Forgot Cellphone Number", "Other"]
    : [];

  const [nameError, setNameError] = useState(false);
  const [surnameError, setSurnameError] = useState(false);
  const [contactError, setContactError] = useState(false);
  const [newContactError, setNewContactError] = useState(false); // Error state for new mobile number
  const [emailError, setEmailError] = useState("");
  const [queryError, setQueryError] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const [messageLength, setMessageLength] = useState(0);

  const [nameTouched, setNameTouched] = useState(false);
  const [surnameTouched, setSurnameTouched] = useState(false);
  const [contactTouched, setContactTouched] = useState(false);
  const [queryTouched, setQueryTouched] = useState(false);
  const [messageTouched, setMessageTouched] = useState(false);
  const [responseCode, setResponseCode] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsButtonDisabled(true);

    const isFormValid =
      nameTouched &&
      !nameError &&
      surnameTouched &&
      !surnameError &&
      contactTouched &&
      !contactError &&
      (!queryType ||
        queryType !== "New / Forgot Cellphone Number" ||
        (newMobileNumber && !newContactError)) &&
      message &&
      !messageError;

    if (isFormValid) {
      const requestData = {
        name,
        surname,
        mobileNumber,
        newMobileNumber:
          queryType === "New / Forgot Cellphone Number"
            ? newMobileNumber
            : undefined,
        email,
        queryType,
        message,
      };

      console.log("Request Data:", requestData);

      const response = await contactUs(
        name,
        surname,
        mobileNumber,
        email,
        queryType,
        message,
        newMobileNumber
      );
      setResponseCode(response.code);

      if (response.code === 200) {
        setModalMessage(
          "GMMDC has been notified of your query. Contact to follow."
        );
      } else {
        setModalMessage("Unable to submit query.");
      }
      setShowModal(true);
    }

    setTimeout(() => setIsButtonDisabled(false), 5000);
  };

  const handleInputChange = (key, value) => {
    switch (key) {
      case "name":
        setName(value);
        break;
      case "surname":
        setSurname(value);
        break;
      case "cellphone":
        setMobileNumber(value);
        break;
      case "newCellphone":
        setNewMobileNumber(value);
        setNewContactError(value === mobileNumber);
        break;
      case "email":
        setEmail(value);
        validateEmail(value);
        break;
      case "queryType":
        setQueryType(value);
        break;
      case "message":
        if (value.length <= 255) {
          setMessage(value);
          setMessageLength(value.length);
        }
        break;
      default:
        break;
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  const handleInputBlur = (key, value) => {
    if (key === "name") {
      setNameTouched(true);
      setNameError(value === "");
    } else if (key === "surname") {
      setSurnameTouched(true);
      setSurnameError(value === "");
    } else if (key === "cellphone" || key === "email") {
      setContactTouched(true);
      const currentCellphone = key === "cellphone" ? value : mobileNumber;
      const currentEmail = key === "email" ? value : email;

      const isMobileValid =
        currentCellphone === "" || /^\d{10}$/.test(currentCellphone);

      const isEmailValid =
        currentEmail === "" || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(currentEmail);

      if (currentCellphone === "" && currentEmail === "") {
        setContactError(true);
      } else if (
        (currentCellphone !== "" && !isMobileValid) ||
        (currentEmail !== "" && !isEmailValid)
      ) {
        setContactError(true);
      } else {
        setContactError(false);
      }
    } else if (key === "queryType") {
      setQueryTouched(true);
      setQueryError(value === "");
    } else if (key === "message") {
      setMessageTouched(true);
      setMessageError(value === "");
    }
  };
  const modalHandler = () => {
    if (responseCode === 200) {
      setShowModal(false);
      history.push("/login");
    } else {
      setShowModal(false);
    }
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const validateEmail = (value: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (value && !emailRegex.test(value)) {
      setEmailError("Invalid email address");
    } else {
      setEmailError("");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: windowWidth >= 800 ? "50%" : "80%",
      }}
    >
      <ContactUsModal
        display={showModal}
        message={modalMessage}
        handler={modalHandler}
      />
      <div>
        <img
          src={
            s3BaseUrl + "/mobitutorza_logo_full.png"
          }
          alt={"MobiTutorZA Logo"}
          width={"250px"}
          height={"250px"}
        />
      </div>

      <div style={{ width: "100%" }}>
        <p style={{ color: "white", fontSize: "1.25em", fontWeight: "bold" }}>
          Contact Us
        </p>
        <hr
          style={{
            color: "white",
            marginBottom: "20px",
            width: "100%",
            //maxWidth: "400px",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: windowWidth >= 800 ? "column" : "column",
          width: "100%",
        }}
      >
        <div style={{ flex: 1, margin: "5px" }}>
          <TextField
            sx={{
              marginTop: "5px",
              backgroundColor: "rgba(224, 224, 224, 0.12)",
              borderRadius: "5px",
              "& .MuiInputBase-input": {
                padding: "15px 14px",
                color: "white",
              },
              "&.Mui-focused": {
                borderColor: "#00112e",
                "--joy-palette-primary-500": "#01ACC7",
              },
              width: "100%",
            }}
            InputProps={{
              sx: {
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FBCD02",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: "white",
                "&.Mui-focused": {
                  color: "#FBCD02",
                },
              },
            }}
            label="Name"
            variant="outlined"
            onChange={(e) => handleInputChange("name", e.target.value)}
            onBlur={(e) => handleInputBlur("name", e.target.value)}
            onKeyDown={handleKeyDown}
            error={nameError}
          />
          {nameError && (
            <Typography
              sx={{
                color: "red",
                fontSize: "0.8rem",

                textAlign: "left",
              }}
            >
              Enter a valid name
            </Typography>
          )}
        </div>

        <div style={{ flex: 1, margin: "5px" }}>
          <TextField
            sx={{
              marginTop: "5px",
              backgroundColor: "rgba(224, 224, 224, 0.12)",
              borderRadius: "5px",
              "& .MuiInputBase-input": {
                padding: "15px 14px",
                color: "white",
              },
              "&.Mui-focused": {
                borderColor: "#00112e",
                "--joy-palette-primary-500": "#01ACC7",
              },
              width: "100%",
            }}
            InputProps={{
              sx: {
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FBCD02",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: "white",
                "&.Mui-focused": {
                  color: "#FBCD02",
                },
              },
            }}
            label="Surname"
            variant="outlined"
            onChange={(e) => handleInputChange("surname", e.target.value)}
            onBlur={(e) => handleInputBlur("surname", e.target.value)}
            onKeyDown={handleKeyDown}
            error={surnameError}
          />
          {surnameError && (
            <Typography
              sx={{
                color: "red",
                fontSize: "0.8rem",

                textAlign: "left",
              }}
            >
              Enter a valid surname
            </Typography>
          )}
        </div>

        <div style={{ flex: 1, margin: "5px" }}>
          <TextField
            sx={{
              marginTop: "5px",
              backgroundColor: "rgba(224, 224, 224, 0.12)",
              borderRadius: "5px",
              "& .MuiInputBase-input": {
                padding: "15px 14px",
                color: "white",
              },
              "&.Mui-focused": {
                borderColor: "#00112e",
                "--joy-palette-primary-500": "#01ACC7",
              },
              width: "100%",
            }}
            InputProps={{
              sx: {
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FBCD02",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: "white",
                "&.Mui-focused": {
                  color: "#FBCD02",
                },
              },
            }}
            label="Email Address"
            variant="outlined"
            value={email}
            onChange={(e) => handleInputChange("email", e.target.value)}
            onBlur={(e) => handleInputBlur("email", e.target.value)}
            onKeyDown={handleKeyDown}
            error={!!emailError}
          />
          {emailError && (
            <Typography
              sx={{
                color: "red",
                fontSize: "0.8rem",
                textAlign: "left",
              }}
            >
              {emailError}
            </Typography>
          )}
        </div>

        {queryType !== "New / Forgot Cellphone Number" && (
            <div id="currectCellPhone" style={{ flex: 1, margin: "5px" }}>
              <TextField
                  sx={{
                    marginTop: "5px",
                    backgroundColor: "rgba(224, 224, 224, 0.12)",
                    borderRadius: "5px",
                    "& .MuiInputBase-input": {
                      padding: "15px 14px",
                      color: "white",
                    },
                    "&.Mui-focused": {
                      borderColor: "#00112e",
                      "--joy-palette-primary-500": "#01ACC7",
                    },
                    width: "100%",
                  }}
                  InputProps={{
                    sx: {
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#FBCD02",
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "white",
                      "&.Mui-focused": {
                        color: "#FBCD02",
                      },
                    },
                  }}
                  label="Cellphone Number"
                  variant="outlined"
                  value={mobileNumber}
                  onChange={(e) => handleInputChange("cellphone", e.target.value)}
                  onBlur={(e) => handleInputBlur("cellphone", e.target.value)}
                  onKeyDown={handleKeyDown}
                  error={contactError}
              />
              {contactError && (
                  <Typography
                      sx={{
                        color: "red",
                        fontSize: "0.8rem",
                        textAlign: "left",
                      }}
                  >
                    Enter a valid cellphone number
                  </Typography>
              )}
            </div>
        )}

        {queryType === "New / Forgot Cellphone Number" && (
            <div style={{ flex: 1, margin: "5px" }}>
              <TextField
                  sx={{
                    marginTop: "5px",
                    backgroundColor: "rgba(224, 224, 224, 0.12)",
                    borderRadius: "5px",
                    "& .MuiInputBase-input": {
                      padding: "15px 14px",
                      color: "white",
                    },
                    "&.Mui-focused": {
                      borderColor: "#00112e",
                      "--joy-palette-primary-500": "#01ACC7",
                    },
                    width: "100%",
                  }}
                  InputProps={{
                    sx: {
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#FBCD02",
                      },
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      color: "white",
                      "&.Mui-focused": {
                        color: "#FBCD02",
                      },
                    },
                  }}
                  label="New Cellphone Number"
                  variant="outlined"
                  onChange={(e) => handleInputChange("newCellphone", e.target.value)}
                  error={newContactError}
              />
              {newContactError && (
                  <Typography
                      sx={{
                        color: "red",
                        fontSize: "0.8rem",
                        textAlign: "left",
                      }}
                  >
                    New number cannot be the same as the current number
                  </Typography>
              )}
            </div>
        )}
      </div>

      <div style={{ width: "100%" }}>
        <div style={{ margin: "5px", marginBottom: "10px", marginTop: "10px" }}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel
              id="query-type-label"
              sx={{
                color: "white",
                "&.Mui-focused": {
                  color: "#FBCD02",
                },
              }}
            >
              Query Type
            </InputLabel>
            <Select
              label="Query Type"
              labelId="query-type-label"
              value={queryType}
              onChange={(e) => handleInputChange("queryType", e.target.value)}
              onBlur={(e) => handleInputBlur("queryType", e.target.value)}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: "#212a41",
                    color: "#ffffff",
                    zIndex: "100",
                    backdropFilter: "none",
                  },
                },
              }}
              sx={{
                color: "white",
                backgroundColor: "rgba(224, 224, 224, 0.12)",
                "& .MuiSelect-select": {
                  padding: "15px 14px",
                  fontSize: "0.875rem",
                  color: "white",
                  textAlign: "left",
                },
                "&:focus .MuiInputLabel-root": {
                  color: "#FBCD02",
                },
                "& .MuiSelect-icon": {
                  color: "white",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FBCD02",
                },
              }}
              displayEmpty
            >
              <MenuItem value="" disabled></MenuItem>
              {options.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  sx={{
                    backgroundColor: "#212a41",
                    "&.Mui-selected": {
                      backgroundColor: "rgb(251, 205, 2)",
                      color: "#00112e",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "rgb(251, 205, 2)",
                    },
                  }}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {queryError && (
            <Typography
              sx={{
                color: "red",
                fontSize: "0.875rem",
                marginTop: "8px",
                textAlign: "left",
              }}
            >
              Please select query type.
            </Typography>
          )}
        </div>
      </div>

      <div style={{ width: "100%" }}>
        <div style={{ margin: "5px", marginBottom: "10px", marginTop: "10px" }}>
          <TextField
            sx={{
              marginTop: "5px",
              backgroundColor: "rgba(224, 224, 224, 0.12)",
              borderRadius: "5px",
              "& .MuiInputBase-input": {
                color: "white",
              },
              "&.Mui-focused": {
                borderColor: "#00112e",
                "--joy-palette-primary-500": "#01ACC7",
              },
              width: "100%",
            }}
            InputProps={{
              sx: {
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#FBCD02",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: "white",
                "&.Mui-focused": {
                  color: "#FBCD02",
                },
              },
            }}
            label="Message"
            variant="outlined"
            multiline
            rows={4}
            value={message}
            onChange={(e) => handleInputChange("message", e.target.value)}
            onBlur={(e) => handleInputBlur("message", e.target.value)}
            onKeyDown={handleKeyDown}
            error={messageError}
          />
          {messageError && (
            <Typography
              sx={{
                color: "red",
                fontSize: "0.8rem",
                textAlign: "left",
              }}
            >
              Please enter a message.
            </Typography>
          )}
          <Typography
            sx={{
              color: "white",
              fontSize: "0.8rem",
              textAlign: "right",
              marginTop: "5px",
            }}
          >
            {255 - messageLength} characters remaining
          </Typography>
        </div>
      </div>

      <div style={{ width: "100%" }}>
        <div style={{ margin: "5px" }}>
          <Button
            variant="contained"
            disabled={isButtonDisabled}
            style={{
              marginTop: "10px",
              marginBottom: "30px",
              backgroundColor: "#FBCD02",
              color: "#00112e",
              width: "100%",
              height: "3.2em",
              fontWeight: "bold",
            }}
            onClick={handleSubmit}
          >
            Contact Us
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
